// import React from 'react';
// import { useEffect } from "react";

// const Banner = ({ }) => {
//   useEffect(() => {
//     const $ = window.$;

//     const timeout = setTimeout(() => {
//       const $carousel = $('.main-slider-carousel');

//       if ($carousel.length) {
//         $carousel.owlCarousel({
//           animateOut: 'fadeOut',
//           animateIn: 'fadeIn',
//           loop: true,
//           margin: 0,
//           nav: true,
//           // autoHeight: true,
//           // autoHeight: false,
//           smartSpeed: 500,
//           autoplay: true, 
//           autoplayTimeout: 6000,
//           navText: [
//             '<span className="flaticon-back-1"></span>',
//             '<span className="flaticon-arrow-pointing-to-right"></span>'
//           ],
//           responsive: {
//             0: { items: 1 },
//             600: { items: 1 },
//             800: { items: 1 },
//             1024: { items: 1 },
//             1200: { items: 1 }
//           }
//         });
//       }
//     }, 300); // slight delay ensures DOM is fully rendered

//     return () => clearTimeout(timeout);
//   }, []);

//   return (
    
//     <section className="banner-section-three">
//       <div className="main-slider-carousel owl-carousel owl-theme">
        
//         {/* Slide 1 */}
//         <div className="slide" style={{ backgroundImage: "url(assets/images/main-slider/image-2.jpg)" }}>
//           <div className="color-layer"></div>
//           <div className="pattern-layer-one" style={{ backgroundImage: "url(assets/images/main-slider/pattern-7.png)" }}></div>
//           <div className="auto-container">
            
//             {/* Content Column */}
//             <div className="content-column clearfix">
//               <div className="inner-column">
//                 {/* <h1>Developing the future. <br /> IT Solutions.</h1> */}
//                 <h1>Website Development Company in Ahmedabad</h1>
//                 <div className="text">
//                 {/* Transform your idea into market-leading web and chrome extensions with our expert team. We deliver exceptional products backed by a business-driven approach. */}
//                 We build clear and fast websites for growing brands. Our team keeps the work simple and smooth. You get a site that feels clean and helps you reach more people.
//                 </div>
//                 <div className="button-box">
//                   <a href="/services" className="theme-btn btn-style-one">
//                     <span className="txt">Learn More</span>
//                   </a>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Slide 2 */}
//         <div className="slide" style={{ backgroundImage: "url(assets/images/main-slider/image-2.jpg)" }}>
//           <div className="color-layer"></div>
//           <div className="pattern-layer-one" style={{ backgroundImage: "url(assets/images/main-slider/pattern-7.png)" }}></div>
//           <div className="auto-container">
            
//             {/* Content Column */}
//             <div className="content-column clearfix">
//               <div className="inner-column">
//                 {/* <h1>THINK. <br />  COLLABORATE.  <br /> LAUNCH.</h1> */}
//                 <h1>Digital Marketing Agency in Ahmedabad</h1>
//                 <div className="text">
//                 {/* The SwiftMaze serves as a trusted partner for businesses in creating bespoke applications with methodical thinking, smart strategies, and advanced technology. */}
//                 Growing your brand online with our digital marketing agency in Ahmedabad. We manage SEO, ads and social media so your business gets more calls and enquiries.
//                 </div>
//                 <div className="button-box">
//                   <a href="/services" className="theme-btn btn-style-one">
//                     <span className="txt">Learn More</span>
//                   </a>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Slide 3 */}
//         <div className="slide" style={{ backgroundImage: "url(assets/images/main-slider/image-2.jpg)" }}>
//           <div className="color-layer"></div>
//           <div className="pattern-layer-one" style={{ backgroundImage: "url(assets/images/main-slider/pattern-7.png)" }}></div>
//           <div className="auto-container">
            
//             {/* Content Column */}
//             <div className="content-column clearfix">
//               <div className="inner-column">
//                 {/* <h1>A Digital Product Agency <br /> that transforms </h1> */}
//                 <h1>Software Development Company in Gujarat</h1>
//                 <div className="text">
//                 {/* We partner with startups and Fortune 500s to create products that inspire customers, increase adoption, strategically, innovative, long-term, refined placement and scale revenue. */}
//                 We make smooth and easy software for teams across Gujarat. Our work fits your daily needs and keeps your process simple. You get tools that feel light and support your business.
//                 </div>
//                 <div className="button-box">
//                   <a href="/services" className="theme-btn btn-style-one">
//                     <span className="txt">Learn More</span>
//                   </a>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//       </div>
//     </section>
//   )
// };

// export default Banner;

















// import React, { useEffect } from "react";

// const HEADER_OFFSET = 140; // top info bar + menu ki approx height, zarurat ho to adjust karna

// const Banner = () => {
//   useEffect(() => {
//     const $ = window.$;

//     const timeout = setTimeout(() => {
//       const $carousel = $(".main-slider-carousel");

//       if ($carousel.length) {
//         $carousel.owlCarousel({
//           animateOut: "fadeOut",
//           animateIn: "fadeIn",
//           loop: true,
//           margin: 0,
//           nav: true,
//           // autoHeight: true,  // âŒ mat chalaana
//           smartSpeed: 500,
//           autoplay: true,
//           autoplayTimeout: 6000,
//           navText: [
//             '<span class="flaticon-back-1"></span>',
//             '<span class="flaticon-arrow-pointing-to-right"></span>',
//           ],
//           responsive: {
//             0: { items: 1 },
//             600: { items: 1 },
//             800: { items: 1 },
//             1024: { items: 1 },
//             1200: { items: 1 },
//           },
//         });
//       }
//     }, 300);

//     return () => clearTimeout(timeout);
//   }, []);

//   return (
//     <section
//       className="banner-section-three"
//       style={{
//         height: `calc(100vh - ${HEADER_OFFSET}px)`,
//         // minHeight: `calc(100vh - ${HEADER_OFFSET}px)`,
//         // overflow: "hidden",
//       }}
//     >
//       <div className="main-slider-carousel owl-carousel owl-theme">
//         {/* Slide 1 */}
//         <div
//           className="slide"
//           style={{
//             backgroundImage: "url(assets/images/main-slider/image-2.jpg)",
//           }}
//         >
//           <div className="color-layer" />
//           <div
//             className="pattern-layer-one"
//             style={{
//               backgroundImage: "url(assets/images/main-slider/pattern-7.png)",
//             }}
//           />
//           <div className="auto-container">
//             <div className="content-column clearfix">
//               <div className="inner-column text-white">
//                 <h2>Website Development Company in Ahmedabad</h2>
//                 <div className="text-base">
//                   We build clear and fast websites for growing brands. Our team
//                   keeps the work simple and smooth. You get a site that feels
//                   clean and helps you reach more people.
//                 </div>
//                 <div className="button-box">
//                   {/* <a href="/services" className="theme-btn btn-style-one">
//                     <span className="txt">Learn More</span>
//                   </a> */}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Slide 2 */}
//         <div
//           className="slide"
//           style={{
//             backgroundImage: "url(assets/images/main-slider/image-2.jpg)",
//           }}
//         >
//           <div className="color-layer" />
//           <div
//             className="pattern-layer-one"
//             style={{
//               backgroundImage: "url(assets/images/main-slider/pattern-7.png)",
//             }}
//           />
//           <div className="auto-container">
//             <div className="content-column clearfix">
//               <div className="inner-column text-white">
//                 <h2>Digital Marketing Agency in Ahmedabad</h2>
//                 <div className="text-base">
//                   Growing your brand online with our digital marketing agency in
//                   Ahmedabad. We manage SEO, ads and social media so your
//                   business gets more calls and enquiries.
//                 </div>
//                 <div className="button-box">
//                   {/* <a href="/services" className="theme-btn btn-style-one">
//                     <span className="txt">Learn More</span>
//                   </a> */}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Slide 3 */}
//         <div
//           className="slide"
//           style={{
//             backgroundImage: "url(assets/images/main-slider/image-2.jpg)",
//           }}
//         >
//           <div className="color-layer" />
//           <div
//             className="pattern-layer-one"
//             style={{
//               backgroundImage: "url(assets/images/main-slider/pattern-7.png)",
//             }}
//           />
//           <div className="auto-container">
//             <div className="content-column clearfix">
//               <div className="inner-column text-white">
//                 <h2>Software Development Company in Gujarat</h2>
//                 <div className="text-base text-bold">
//                   We make smooth and easy software for teams across Gujarat. Our
//                   work fits your daily needs and keeps your process simple. You
//                   get tools that feel light and support your business.
//                 </div>
//                 <div className="button-box">
//                   {/* <a href="/services" className="theme-btn btn-style-one">
//                     <span className="txt">Learn More</span>
//                   </a> */}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Banner;









// import React, { useEffect } from "react";

// const HEADER_OFFSET = 140;

// const Banner = () => {
//   useEffect(() => {
//     const $ = window.$;

//     const timeout = setTimeout(() => {
//       const $carousel = $(".main-slider-carousel");

//       if ($carousel.length) {
//         $carousel.owlCarousel({
//           animateOut: "fadeOut",
//           animateIn: "fadeIn",
//           loop: true,
//           margin: 0,
//           nav: true,
//           smartSpeed: 500,
//           autoplay: true,
//           autoplayTimeout: 6000,
//           navText: [
//             '<span class="flaticon-back-1"></span>',
//             '<span class="flaticon-arrow-pointing-to-right"></span>',
//           ],
//           responsive: {
//             0: { items: 1 },
//             600: { items: 1 },
//             800: { items: 1 },
//             1024: { items: 1 },
//             1200: { items: 1 },
//           },
//         });
//       }
//     }, 300);

//     return () => clearTimeout(timeout);
//   }, []);

//   return (
//     <section
//       className="banner-section-three"
//       style={{
//         height: `calc(100vh - ${HEADER_OFFSET}px)`,
//       }}
//     >
//       <div className="main-slider-carousel owl-carousel owl-theme">

//         {/* ---------------- SLIDE 1 ---------------- */}
//         <div
//           className="slide"
//           style={{
//             backgroundImage: "url(assets/images/main-slider/image-2.jpg)",
//           }}
//         >
//           <div className="color-layer" />
//           <div
//             className="pattern-layer-one"
//             style={{
//               backgroundImage: "url(assets/images/main-slider/pattern-7.png)",
//             }}
//           />
//           <div className="auto-container">
//             <div className="content-column clearfix">
//               <div className="inner-column text-white">
//                 <h2>Website Development Company in Ahmedabad</h2>
//                 <div className="text-base">
//                   We build clear and fast websites for growing brands.  
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* ---------------- SLIDE 2 ---------------- */}
//         <div
//           className="slide"
//           style={{
//             backgroundImage: "url(assets/images/main-slider/image-2.jpg)",
//           }}
//         >
//           <div className="color-layer" />
//           <div
//             className="pattern-layer-one"
//             style={{
//               backgroundImage: "url(assets/images/main-slider/pattern-7.png)",
//             }}
//           />
//           <div className="auto-container">
//             <div className="content-column clearfix">
//               <div className="inner-column text-white">
//                 <h2>Digital Marketing Agency in Ahmedabad</h2>
//                 <div className="text-base">
//                   We manage SEO, ads and social media so your business grows.
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* ---------------- SLIDE 3 (FORM ADDED HERE) ---------------- */}
//         <div
//           className="slide"
//           style={{
//             backgroundImage: "url(assets/images/main-slider/image-2.jpg)",
//           }}
//         >
//           <div className="color-layer" />
//           <div
//             className="pattern-layer-one"
//             style={{
//               backgroundImage: "url(assets/images/main-slider/pattern-7.png)",
//             }}
//           />

//           <div className="auto-container">
//             <div className="content-column clearfix" style={{ display: "flex", gap: "40px" }}>

//               {/* LEFT SIDE TEXT */}
//               <div className="inner-column text-white" style={{ flex: 1 }}>
//                 <h2>Software Development Company in Gujarat</h2>
//                 <div className="text-base">
//                   We make smooth and easy software for teams across Gujarat.
//                 </div>
//               </div>

//               {/* RIGHT SIDE FORM */}
//               <div
//                 className="form-box"
//                 style={{
//                   flex: "0 0 320px",
//                   background: "white",
//                   color: "black",
//                   padding: "20px",
//                   borderRadius: "12px",
//                   boxShadow: "0 4px 15px rgba(0,0,0,0.15)",
//                   height: "fit-content",
//                 }}
//               >
//                 <h3 style={{ fontSize: "20px", fontWeight: 600, marginBottom: "10px" }}>
//                   Book a Free Consultation
//                 </h3>

//                 <form>
//                   <label>Name</label>
//                   <input
//                     type="text"
//                     placeholder="Enter name"
//                     className="homeInput"
//                   />

//                   <label>Mobile Number</label>
//                   <input
//                     type="tel"
//                     placeholder="Enter number"
//                     className="homeInput"
//                   />

//                   <label>Email</label>
//                   <input
//                     type="email"
//                     placeholder="Enter email"
//                     className="homeInput"
//                   />

//                   <button
//                     type="submit"
//                     style={{
//                       width: "100%",
//                       marginTop: "10px",
//                       padding: "10px",
//                       background: "#3595E4",
//                       color: "white",
//                       borderRadius: "6px",
//                       fontSize: "16px",
//                       border: "none",
//                       cursor: "pointer",
//                     }}
//                   >
//                     Submit
//                   </button>
//                 </form>
//               </div>
//               {/* END FORM */}
//             </div>
//           </div>
//         </div>

//       </div>
//     </section>
//   );
// };

// const inputStyle = {
//   width: "100%",
//   padding: "8px",
//   marginBottom: "12px",
//   borderRadius: "6px",
//   border: "1px solid #ddd",
//   fontSize: "14px",
// };

// export default Banner;











//BEFORE FINAL
// import React, { useEffect } from "react";

// const HEADER_OFFSET = 140; // jitna tu pehle use kar raha tha

// const Banner = () => {
//   useEffect(() => {
//     const $ = window.$;

//     const timeout = setTimeout(() => {
//       const $carousel = $(".main-slider-carousel");

//       if ($carousel.length) {
//         $carousel.owlCarousel({
//           animateOut: "fadeOut",
//           animateIn: "fadeIn",
//           loop: true,
//           margin: 0,
//           nav: true,
//           smartSpeed: 500,
//           autoplay: true,
//           autoplayTimeout: 6000,
//           navText: [
//             '<span class="flaticon-back-1"></span>',
//             '<span class="flaticon-arrow-pointing-to-right"></span>',
//           ],
//           responsive: {
//             0: { items: 1 },
//             600: { items: 1 },
//             800: { items: 1 },
//             1024: { items: 1 },
//             1200: { items: 1 },
//           },
//         });
//       }
//     }, 300);

//     return () => clearTimeout(timeout);
//   }, []);
// const renderForm = () => (
//   <div className="banner-form-box">
//     <h3 className="banner-form-title">Book a Free Consultation</h3>

//     <form>
//       {/* Name */}
//       <div style={{ marginBottom: "14px" }}>
//         <label className="home_label">Name</label>
//         <input
//           type="text"
//           placeholder="Enter your name"
//           className="homeInput"
//         />
//       </div>

//       {/* Mobile */}
//       <div style={{ marginBottom: "14px" }}>
//         <label className="home_label">
//           Mobile Number<span style={{ color: "#e11d48" }}> *</span>
//         </label>

//         <div style={{ display: "flex" }}>
//           <select className="homeCountrySelect">
//             <option value="+91">+91 (IN)</option>
//             <option value="+1">+1 (US)</option>
//             <option value="+44">+44 (UK)</option>
//             <option value="+61">+61 (AU)</option>
//             <option value="+1-CA">+1 (CA)</option>
//           </select>

//           <input
//             type="tel"
//             placeholder="10 digit mobile"
//             className="homeInput"
//             style={{
//               borderTopLeftRadius: 0,
//               borderBottomLeftRadius: 0,
//               borderLeft: "0",
//               marginBottom: 0,
//             }}
//           />
//         </div>
//       </div>

//       {/* ðŸ”½ Service / Requirement dropdown */}
//       <div style={{ marginBottom: "14px" }}>
//         <label className="home_label">What do you need?</label>
//         <select className="homeInput">
//           <option value="">Select service</option>
//           <option value="website-development">Website development</option>
//           <option value="web-app-software">Web application / custom software</option>
//           <option value="chrome-extension">Chrome / browser extension development</option>
//           <option value="ecommerce-website">E-commerce website</option>
//           <option value="landing-page-funnel">Landing page / funnel</option>
//           <option value="mobile-app">Mobile app development</option>
//           <option value="maintenance-support">Maintenance & support</option>
//         </select>
//       </div>

//       {/* Email */}
//       <div style={{ marginBottom: "14px" }}>
//         <label className="home_label">Email</label>
//         <input
//           type="email"
//           placeholder="you@example.com"
//           className="homeInput"
//         />
//       </div>

//       <button type="submit" className="homeSubmitButton">
//         Submit
//       </button>
//     </form>
//   </div>
// );


//   return (
//     <section
//       className="banner-section-three"
//       style={{
//         height: `calc(100vh - ${HEADER_OFFSET}px)`,
//       }}
//     >
//       <div className="main-slider-carousel owl-carousel owl-theme">
//         {/* ------------ SLIDE 1 ------------ */}
//         <div
//           className="slide"
//           style={{
//             backgroundImage: "url(assets/images/main-slider/image-2.jpg)",
//             position: "relative",  // IMPORTANT
//           }}
//         >
//           <div className="color-layer" />
//           <div
//             className="pattern-layer-one"
//             style={{
//               backgroundImage: "url(assets/images/main-slider/pattern-7.png)",
//             }}
//           />

//           <div className="auto-container">
//             <div className="content-column clearfix">
//               <div className="inner-column-Banner text-white">
//                 <h2>Website Development Company in Ahmedabad</h2>
//                 <div className="text-base">
//                   We build clear and fast websites for growing brands. Our team
//                   keeps the work simple and smooth. You get a site that feels
//                   clean and helps you reach more people.
//                 </div>
//               </div>
//             </div>
//           </div>

//           {renderForm()}
//         </div>

//         {/* ------------ SLIDE 2 ------------ */}
//         <div
//           className="slide"
//           style={{
//             backgroundImage: "url(assets/images/main-slider/image-2.jpg)",
//             position: "relative",
//           }}
//         >
//           <div className="color-layer" />
//           <div
//             className="pattern-layer-one"
//             style={{
//               backgroundImage: "url(assets/images/main-slider/pattern-7.png)",
//             }}
//           />

//           <div className="auto-container">
//             <div className="content-column clearfix">
//               <div className="inner-column-Banner text-white">
//                 <h2>Digital Marketing Agency in Ahmedabad</h2>
//                 <div className="text-base">
//                   Growing your brand online with our digital marketing agency in
//                   Ahmedabad. We manage SEO, ads and social media so your
//                   business gets more calls and enquiries.
//                 </div>
//               </div>
//             </div>
//           </div>

//           {renderForm()}
//         </div>

//         {/* ------------ SLIDE 3 ------------ */}
//         <div
//           className="slide"
//           style={{
//             backgroundImage: "url(assets/images/main-slider/image-2.jpg)",
//             position: "relative",
//           }}
//         >
//           <div className="color-layer" />
//           <div
//             className="pattern-layer-one"
//             style={{
//               backgroundImage: "url(assets/images/main-slider/pattern-7.png)",
//             }}
//           />

//           <div className="auto-container">
//             <div className="content-column clearfix">
//               <div className="inner-column-Banner text-white">
//                 <h2>Software Development Company in Gujarat</h2>
//                 <div className="text-base text-bold">
//                   We make smooth and easy software for teams across Gujarat. Our
//                   work fits your daily needs and keeps your process simple. You
//                   get tools that feel light and support your business.
//                 </div>
//               </div>
//             </div>
//           </div>

//           {renderForm()}
//         </div>
//       </div>
//     </section>
//   );
// };
// export default Banner;







//Before  on 3-1-26 (Before Country validation)

// import React, { useEffect, useState } from "react";

// const HEADER_OFFSET = 140; // jitna tu pehle use kar raha tha

// const Banner = () => {
//   // useEffect(() => {
    
//   //   const $ = window.$;

//   //   const timeout = setTimeout(() => {
//   //     const $carousel = $(".main-slider-carousel");

//   //     if ($carousel.length) {
//   //       $carousel.owlCarousel({
//   //         animateOut: "fadeOut",
//   //         animateIn: "fadeIn",
//   //         loop: true,
//   //         margin: 0,
//   //         nav: true,
//   //         smartSpeed: 500,
//   //         autoplay: true,
//   //         autoplayTimeout: 6000,
//   //         navText: [
//   //           '<span class="flaticon-back-1"></span>',
//   //           '<span class="flaticon-arrow-pointing-to-right"></span>',
//   //         ],
//   //         responsive: {
//   //           0: { items: 1 },
//   //           600: { items: 1 },
//   //           800: { items: 1 },
//   //           1024: { items: 1 },
//   //           1200: { items: 1 },
//   //         },
//   //       });
//   //     }


//   //   }, 300);
//   //   return () => clearTimeout(timeout);
//   // }, []);

//     useEffect(() => {
//     // browser + jQuery check (optional but safe)
//     if (typeof window === "undefined" || !window.$) return;

//     const $ = window.$;

//     const timeout = setTimeout(() => {
//       // ====== OWL CAROUSEL (tera existing code) ======
//       const $carousel = $(".main-slider-carousel");

//       if ($carousel.length) {
//         $carousel.owlCarousel({
//           animateOut: "fadeOut",
//           animateIn: "fadeIn",
//           loop: true,
//           margin: 0,
//           nav: true,
//           smartSpeed: 500,
//           autoplay: true,
//           autoplayTimeout: 6000,
//           navText: [
//             '<span class="flaticon-back-1"></span>',
//             '<span class="flaticon-arrow-pointing-to-right"></span>',
//           ],
//           responsive: {
//             0: { items: 1 },
//             600: { items: 1 },
//             800: { items: 1 },
//             1024: { items: 1 },
//             1200: { items: 1 },
//           },
//         });
//       }

//       // ====== STICKY HEADER NAV CLONE (yahi main kaam hai) ======
//       const $navOuter = $(".main-header .nav-outer");        // original full right side
//       const $stickyRight = $(".sticky-header .pull-right");  // sticky header right side

//       if (
//         $navOuter.length &&
//         $stickyRight.length &&
//         $stickyRight.is(":empty") // overwrite sirf jab khaali ho
//       ) {
//         $stickyRight.html($navOuter.html());
//       }
//     }, 300);

//     return () => clearTimeout(timeout);
//   }, []);

// const [bannerForm, setBannerForm] = useState({
//   name: "",
//   phone: "",
//   email: "",
//   service: "",
// });

// const [bannerLoading, setBannerLoading] = useState(false);
// const [bannerStatus, setBannerStatus] = useState({ success: "", error: "" });


// const botToken = '7869975126:AAETFptfICnYosInsBlMFWlfOpeeGAl_s10'; 
// 	const chatId = '-1002662497260';

// const handleBannerChange = (e) => {
//   const { name, value } = e.target;
//   setBannerForm((prev) => ({ ...prev, [name]: value }));
// };

// const handleBannerSubmit = async (e) => {
//   e.preventDefault();
//   setBannerLoading(true);
//   setBannerStatus({ success: "", error: "" });

//   // basic validation â€“ phone required
//   if (!bannerForm.phone.trim()) {
//     setBannerStatus({ success: "", error: "Please enter your mobile number." });
//     setBannerLoading(false);
//     return;
//   }

//   let ipInfo = {};
//   try {
//     const res = await fetch("https://ipapi.co/json");
//     ipInfo = await res.json();
//   } catch (err) {
//     console.warn("Failed to get IP/location info:", err);
//   }

//   const ip = ipInfo.ip || "Unknown";
//   const city = ipInfo.city || "";
//   const region = ipInfo.region || "";
//   const country = ipInfo.country_name || "";
//   const locationStr =
//     city || region || country ? `${city},${region},${country}` : "Unknown";
//   const isp = ipInfo.org || "Unknown";
//   const userAgent = navigator.userAgent;
//   const now = new Date();
//   const timeStr = now.toLocaleTimeString();
//   const dateStr = now.toLocaleDateString("en-GB");
//   const whatsappLink = bannerForm.phone
//     ? `https://wa.me/${bannerForm.phone.replace(/\D/g, "")}`
//     : "";
//   const currentUrl = window.location.href;

//   const msg = `
// ðŸ“© *New Home Banner Lead*
// siteName: "SwiftMaze Tech",
// formName: "Homepage Form",

// ðŸ‘¤ *Name:* ${bannerForm.name || "-"}
// ðŸ“± *Phone:* ${bannerForm.phone}${
//     whatsappLink ? ` ([WhatsApp Link](${whatsappLink}))` : ""
//   }
// ðŸ·ï¸ *Service Needed:* ${bannerForm.service || "-"}
// ðŸ“§ *Email:* ${
//     bannerForm.email
//       ? `[${bannerForm.email}](mailto:${bannerForm.email})`
//       : "-"
//   }

// ðŸ” *IP Address:* ${ip}
// ðŸ“ *Location:* ${locationStr}
// ðŸŒ *ISP:* ${isp}
// ðŸ–¥ï¸ *Device:* ${userAgent}
// ðŸ•’ *Time:* ${timeStr}, ${dateStr}
// ðŸ”— *Source URL:* ${currentUrl}
// `.trim();

//   try {
//     const telegramRes = await fetch(
//       `https://api.telegram.org/bot${botToken}/sendMessage`,
//       {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           chat_id: chatId,
//           text: msg,
//           parse_mode: "Markdown",
//         }),
//       }
//     );

//     if (telegramRes.ok) {
//       setBannerStatus({
//         success:
//           "âœ… Thank you! Your request has been received. We will get back to you shortly.",
//         error: "",
//       });

//       setBannerForm({
//         name: "",
//         phone: "",
//         email: "",
//         service: "",
//       });
//     } else {
//       setBannerStatus({
//         success: "",
//         error:
//           "âš ï¸ Sorry! We couldn't send your request. Please try again in a few minutes.",
//       });
//     }
//   } catch (err) {
//     console.error("Error sending to Telegram:", err);
//     setBannerStatus({
//       success: "",
//       error:
//         "âš ï¸ Something went wrong. Please check your internet connection and try again later.",
//     });
//   }

//   setBannerLoading(false);
// };
// const renderForm = () => (
//   <div className="banner-form-box">
//     <h3 className="banner-form-title">Book a Free Consultation</h3>

//     {/* Success / error from banner form */}
//     {bannerStatus.success && (
//       <div
//         style={{
//           backgroundColor: "#e6ffed",
//           border: "1px solid #2ecc71",
//           padding: "8px",
//           borderRadius: "6px",
//           marginBottom: "10px",
//           color: "#2e7d32",
//           fontSize: "13px",
//         }}
//       >
//         {bannerStatus.success}
//       </div>
//     )}
//     {bannerStatus.error && (
//       <div
//         style={{
//           backgroundColor: "#ffe6e6",
//           border: "1px solid #e74c3c",
//           padding: "8px",
//           borderRadius: "6px",
//           marginBottom: "10px",
//           color: "#c0392b",
//           fontSize: "13px",
//         }}
//       >
//         {bannerStatus.error}
//       </div>
//     )}

//     <form onSubmit={handleBannerSubmit}>
//       {/* Name */}
//       <div style={{ marginBottom: "14px" }}>
//         <label className="home_label">Name</label>
//         <input
//           type="text"
//           name="name"
//           placeholder="Enter your name"
//           className="homeInput"
//           value={bannerForm.name}
//           onChange={handleBannerChange}
//         />
//       </div>

//       {/* Mobile */}
//       <div style={{ marginBottom: "14px" }}>
//         <label className="home_label">
//           Mobile Number<span style={{ color: "#e11d48" }}> *</span>
//         </label>

//         <div style={{ display: "flex" }}>
//           <select className="homeCountrySelect">
//             <option value="+91">+91 (IN)</option>
//             <option value="+1">+1 (US)</option>
//             <option value="+44">+44 (UK)</option>
//             <option value="+61">+61 (AU)</option>
//             <option value="+1-CA">+1 (CA)</option>
//           </select>

//           <input
//             type="tel"
//             name="phone"
//             placeholder="10 digit mobile"
//             className="homeInput"
//             style={{
//               borderTopLeftRadius: 0,
//               borderBottomLeftRadius: 0,
//               borderLeft: "0",
//               marginBottom: 0,
//             }}
//             value={bannerForm.phone}
//             onChange={handleBannerChange}
//           />
//         </div>
//       </div>

//       {/* Service dropdown */}
//       <div style={{ marginBottom: "14px" }}>
//         <label className="home_label">What do you need?</label>
//         <select
//           name="service"
//           className="homeInput"
//           value={bannerForm.service}
//           onChange={handleBannerChange}
//         >
//           <option value="">Select service</option>
//           <option value="website-development">Website development</option>
//           <option value="web-app-software">
//             Web application / custom software
//           </option>
//           <option value="chrome-extension">
//             Chrome / browser extension development
//           </option>
//           <option value="ecommerce-website">E-commerce website</option>
//           <option value="landing-page-funnel">Landing page / funnel</option>
//           <option value="mobile-app">Mobile app development</option>
//           <option value="maintenance-support">Maintenance &amp; support</option>
//         </select>
//       </div>

//       {/* Email */}
//       <div style={{ marginBottom: "14px" }}>
//         <label className="home_label">Email</label>
//         <input
//           type="email"
//           name="email"
//           placeholder="you@example.com"
//           className="homeInput"
//           value={bannerForm.email}
//           onChange={handleBannerChange}
//         />
//       </div>

//       <button
//         type="submit"
//         className="homeSubmitButton"
//         disabled={bannerLoading}
        
//       >
//       <span>{bannerLoading ? "Sending..." : "Submit"}</span>
//       </button>
//     </form>
//   </div>
// );

//     return (
//     // <section
//     //   className="banner-section-three"
//     //   style={{
//     //     height: `calc(100vh - ${HEADER_OFFSET}px)`,
//     //   }}
//     // >
//  <section className="banner-section-three">

//       <div className="main-slider-carousel owl-carousel owl-theme">
//         {/* ------------ SLIDE 1 ------------ */}
//         <div
//           className="slide"
//           style={{
//             backgroundImage: "url(assets/images/main-slider/image-2.jpg)",
//             position: "relative",  // IMPORTANT
//           }}
//         >
//           <div className="color-layer" />
//           <div
//             className="pattern-layer-one"
//             style={{
//               backgroundImage: "url(assets/images/main-slider/pattern-7.png)",
//             }}
//           />

//           <div className="auto-container">
//             <div className="content-column clearfix">
//               <div className="inner-column-Banner text-white">
//                 <h1>Website Development Company in Ahmedabad</h1>
//                 <div className="text-base">
//                   We build clear and fast websites for growing brands. Our team
//                   keeps the work simple and smooth. You get a site that feels
//                   clean and helps you reach more people.
//                 </div>
//               </div>
//             </div>
//           </div>

//           {renderForm()}
//         </div>

//         {/* ------------ SLIDE 2 ------------ */}
//         <div
//           className="slide"
//           style={{
//             backgroundImage: "url(assets/images/main-slider/image-2.jpg)",
//             position: "relative",
//           }}
//         >
//           <div className="color-layer" />
//           <div
//             className="pattern-layer-one"
//             style={{
//               backgroundImage: "url(assets/images/main-slider/pattern-7.png)",
//             }}
//           />

//           <div className="auto-container">
//             <div className="content-column clearfix">
//               <div className="inner-column-Banner text-white">
//                 <h2>Digital Marketing Agency in Ahmedabad</h2>
//                 <div className="text-base">
//                   Growing your brand online with our digital marketing agency in
//                   Ahmedabad. We manage SEO, ads and social media so your
//                   business gets more calls and enquiries.
//                 </div>
//               </div>
//             </div>
//           </div>

//           {renderForm()}
//         </div>

//         {/* ------------ SLIDE 3 ------------ */}
//         <div
//           className="slide"
//           style={{
//             backgroundImage: "url(assets/images/main-slider/image-2.jpg)",
//             position: "relative",
//           }}
//         >
//           <div className="color-layer" />
//           <div
//             className="pattern-layer-one"
//             style={{
//               backgroundImage: "url(assets/images/main-slider/pattern-7.png)",
//             }}
//           />

//           <div className="auto-container">
//             <div className="content-column clearfix">
//               <div className="inner-column-Banner text-white">
//                 <h2>Software Development Company in Gujarat</h2>
//                 <div className="text-base text-bold">
//                   We make smooth and easy software for teams across Gujarat. Our
//                   work fits your daily needs and keeps your process simple. You
//                   get tools that feel light and support your business.
//                 </div>
//               </div>
//             </div>
//           </div>

//           {renderForm()}
//         </div>
//       </div>
//     </section>
//   );
// };
// export default Banner;


// After 3-1-26
import React, { useEffect, useState } from "react";
import { FaWhatsapp } from "react-icons/fa";
import heroDigitalMarketingImage from "../assets/images/main-slider/digital-marketing-hero.png";
import heroMobileAppImage from "../assets/images/main-slider/mobile-app-development-hero.png";
import heroSoftwareDevelopmentImage from "../assets/images/main-slider/software-erp-development-hero.png";
import { sendInquiryEmail } from "../utils/inquiryEmail";
import * as inquiry from "./inquirySubmission";

const HEADER_OFFSET = 140;

// âœ… Country phone rules
const isValidEmail = (email) => {
  const v = (email || "").trim();
  if (!v) return true; // email optional
  return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i.test(v);
};

const digitsOnly = (v) => (v || "").replace(/\D/g, "");
const preventNonNumeric = (e) => {
  const allowedKeys = [
    "Backspace",
    "Delete",
    "Tab",
    "Escape",
    "Enter",
    "ArrowLeft",
    "ArrowRight",
    "Home",
    "End",
  ];

  // allow ctrl/cmd shortcuts: copy/paste/select all
  if (e.ctrlKey || e.metaKey) return;

  // allow navigation keys
  if (allowedKeys.includes(e.key)) return;

  // allow only digits
  if (!/^\d$/.test(e.key)) {
    e.preventDefault();
  }
  
};
const Banner = () => {
  const [isCarouselReady, setIsCarouselReady] = useState(false);
  const [deferredSlidesReady, setDeferredSlidesReady] = useState(false);
  const softwareSlideImage = heroSoftwareDevelopmentImage;

  useEffect(() => {
    if (typeof document === "undefined") return undefined;

    const preloadLink = document.createElement("link");
    preloadLink.rel = "preload";
    preloadLink.as = "image";
    preloadLink.href = heroMobileAppImage;
    preloadLink.setAttribute("data-swiftmaze-preload", "home-hero");
    document.head.appendChild(preloadLink);

    return () => {
      if (preloadLink.parentNode) {
        preloadLink.parentNode.removeChild(preloadLink);
      }
    };
  }, []);

  useEffect(() => {
    if (typeof window === "undefined") return undefined;

    const loadDeferredSlides = () => {
      [heroDigitalMarketingImage, softwareSlideImage].forEach((src) => {
        const img = new Image();
        img.src = src;
      });
      setDeferredSlidesReady(true);
    };

    let timeoutId;
    if ("requestIdleCallback" in window) {
      const idleId = window.requestIdleCallback(loadDeferredSlides, { timeout: 1800 });
      return () => window.cancelIdleCallback(idleId);
    }

    timeoutId = window.setTimeout(loadDeferredSlides, 1200);
    return () => window.clearTimeout(timeoutId);
  }, [softwareSlideImage]);

  useEffect(() => {
    const isReactSnapCrawler =
      typeof navigator !== "undefined" &&
      /ReactSnap/i.test(navigator.userAgent || "");

    // Prevent react-snap from freezing Owl's inline stage markup into build/index.html
    if (isReactSnapCrawler) {
      setIsCarouselReady(true);
      return;
    }

    if (typeof window === "undefined" || !window.$) {
      setIsCarouselReady(true);
      return;
    }
    const $ = window.$;
    if (!$.fn || typeof $.fn.owlCarousel !== "function") {
      setIsCarouselReady(true);
      return;
    }
    const $carousel = $(".main-slider-carousel");
    if (!$carousel.length) {
      setIsCarouselReady(true);
      return;
    }

    if ($carousel.hasClass("owl-loaded")) {
      $carousel.trigger("destroy.owl.carousel");
      $carousel.removeClass("owl-loaded owl-hidden owl-refresh owl-drag");
      $carousel.find(".owl-stage-outer").children().unwrap();
      $carousel.find(".owl-stage").children().unwrap();
    }

    $carousel.one("initialized.owl.carousel", () => {
      setIsCarouselReady(true);
    });

    try {
      $carousel.owlCarousel({
        animateOut: "fadeOut",
        animateIn: "fadeIn",
        loop: true,
        margin: 0,
        nav: true,
        smartSpeed: 500,
        autoplay: true,
        autoplayTimeout: 6000,
        navText: [
          '<span class="flaticon-back-1"></span>',
          '<span class="flaticon-arrow-pointing-to-right"></span>',
        ],
        responsive: {
          0: { items: 1 },
          600: { items: 1 },
          800: { items: 1 },
          1024: { items: 1 },
          1200: { items: 1 },
        },
      });
    } catch (error) {
      setIsCarouselReady(true);
    }

    // Safety fallback: if init event misses, do not keep loading state.
    const readyTimeout = setTimeout(() => {
      setIsCarouselReady(true);
    }, 900);

    const $navOuter = $(".main-header .nav-outer");
    const $stickyRight = $(".sticky-header .pull-right");
    if ($navOuter.length && $stickyRight.length && $stickyRight.is(":empty")) {
      $stickyRight.html($navOuter.html());
    }

    return () => {
      clearTimeout(readyTimeout);
      $carousel.off("initialized.owl.carousel");
    };
  }, []);

  // âœ… state me countryCode add
  const [bannerForm, setBannerForm] = useState({
    name: "",
    countryCode: inquiry.DEFAULT_COUNTRY_CODE,
    phone: "",
    email: "",
    service: "",
  });

  const [bannerLoading, setBannerLoading] = useState(false);
  const [bannerStatus, setBannerStatus] = useState({ success: "", error: "" });

  // Telegram submission kept for future use. Email submission is active now.
  // const botToken = '7869975126:AAETFptfICnYosInsBlMFWlfOpeeGAl_s10';
  // const chatId = '-1002662497260';

  // âœ… updated handleBannerChange (country + phone logic)
  const handleBannerChange = (e) => {
    const { name, value } = e.target;

    // country code change
    if (name === "countryCode") {
      const nextCode = value;
      const rule = inquiry.getCountryPhoneRule(nextCode);

      setBannerForm((prev) => ({
        ...prev,
        countryCode: nextCode,
        phone: digitsOnly(prev.phone).slice(0, rule.maxDigits), // trim existing phone
      }));
      return;
    }

    // phone change: digits only + max digits
    if (name === "phone") {
      const code = bannerForm.countryCode || inquiry.DEFAULT_COUNTRY_CODE;
      const rule = inquiry.getCountryPhoneRule(code);

      const cleaned = digitsOnly(value).slice(0, rule.maxDigits);

      setBannerForm((prev) => ({ ...prev, phone: cleaned }));
      return;
    }

    // others
    setBannerForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleBannerSubmit = async (e) => {
    e.preventDefault();
    setBannerLoading(true);
    setBannerStatus({ success: "", error: "" });

    const code = bannerForm.countryCode || inquiry.DEFAULT_COUNTRY_CODE;
    const phoneDigits = digitsOnly(bannerForm.phone);

    if (!phoneDigits) {
      setBannerStatus({ success: "", error: "Please enter your mobile number." });
      setBannerLoading(false);
      return;
    }

    if (!inquiry.isValidPhoneNumber(code, phoneDigits)) {
      setBannerStatus({
        success: "",
        error: inquiry.getPhoneValidationMessage(code),
      });
      setBannerLoading(false);
      return;
    }

    if (!isValidEmail(bannerForm.email)) {
      setBannerStatus({
        success: "",
        error: "Please enter a valid email address.",
      });
      setBannerLoading(false);
      return;
    }

    const fullPhone = `${inquiry.getDialCode(code)}${phoneDigits}`;

    try {
      await sendInquiryEmail({
        formName: "Homepage Form",
        name: bannerForm.name,
        email: bannerForm.email,
        phone: fullPhone,
        service: bannerForm.service,
        message: bannerForm.service || "Homepage banner inquiry",
      });

      // Telegram submission kept for future use. Email submission is active now.
      // await fetch(`https://api.telegram.org/bot${botToken}/sendMessage`, {
      //   method: "POST",
      //   headers: { "Content-Type": "application/json" },
      //   body: JSON.stringify({ chat_id: chatId, text: msg, parse_mode: "Markdown" }),
      // });

      setBannerStatus({
        success: "Thank you! Your request has been received. We will get back to you shortly.",
        error: "",
      });

      setBannerForm({
        name: "",
        countryCode: inquiry.DEFAULT_COUNTRY_CODE,
        phone: "",
        email: "",
        service: "",
      });
    } catch (err) {
      console.error("Error sending inquiry email:", err);
      setBannerStatus({
        success: "",
        error: "Something went wrong. Please check your internet connection and try again later.",
      });
    }

    setBannerLoading(false);
  };

  // const renderForm = () => {
  //   const code = bannerForm.countryCode || "+91";
  //   const rule = COUNTRY_PHONE_RULES[code] || { maxDigits: 15, placeholder: "Mobile number" };

  //   return (
  //     <div className="banner-form-box">
  //       <h3 className="banner-form-title">Book a Free Consultation</h3>

  //       {bannerStatus.success && (
  //         <div
  //           style={{
  //             backgroundColor: "#e6ffed",
  //             border: "1px solid #2ecc71",
  //             padding: "8px",
  //             borderRadius: "6px",
  //             marginBottom: "10px",
  //             color: "#2e7d32",
  //             fontSize: "13px",
  //           }}
  //         >
  //           {bannerStatus.success}
  //         </div>
  //       )}
  //       {bannerStatus.error && (
  //         <div
  //           style={{
  //             backgroundColor: "#ffe6e6",
  //             border: "1px solid #e74c3c",
  //             padding: "8px",
  //             borderRadius: "6px",
  //             marginBottom: "10px",
  //             color: "#c0392b",
  //             fontSize: "13px",
  //           }}
  //         >
  //           {bannerStatus.error}
  //         </div>
  //       )}

  //       <form onSubmit={handleBannerSubmit}>
  //         {/* Name */}
  //         <div style={{ marginBottom: "14px" }}>
  //           <label className="home_label">Name</label>
  //           <input
  //             type="text"
  //             name="name"
  //             placeholder="Enter your name"
  //             className="homeInput"
  //             value={bannerForm.name}
  //             onChange={handleBannerChange}
  //           />
  //         </div>

  //         {/* Mobile */}
  //         <div style={{ marginBottom: "14px" }}>
  //           <label className="home_label">
  //             Mobile Number<span style={{ color: "#e11d48" }}> *</span>
  //           </label>

  //           <div style={{ display: "flex" }}>
  //             {/* âœ… connected select */}
  //             <select
  //               className="homeCountrySelect"
  //               name="countryCode"
  //               value={bannerForm.countryCode}
  //               onChange={handleBannerChange}
  //             >
  //               <option value="+91">+91 (IN)</option>
  //               <option value="+1">+1 (US)</option>
  //               <option value="+44">+44 (UK)</option>
  //               <option value="+61">+61 (AU)</option>
  //               <option value="+1-CA">+1 (CA)</option>
  //             </select>

  //             <input
  //             onKeyDown={preventNonNumeric}
  //               type="tel"
  //               name="phone"
  //               inputMode="numeric"
  //               autoComplete="tel"
  //               placeholder={rule.placeholder}
  //               className="homeInput"
  //               style={{
  //                 borderTopLeftRadius: 0,
  //                 borderBottomLeftRadius: 0,
  //                 borderLeft: "0",
  //                 marginBottom: 0,
  //               }}
  //               value={bannerForm.phone}
  //               onChange={handleBannerChange}
  //               maxLength={rule.maxDigits} // âœ… UI limit
  //               required
  //               pattern="\d*"
  //             />
  //           </div>
  //         </div>

  //         {/* Service dropdown */}
  //         <div style={{ marginBottom: "14px" }}>
  //           <label className="home_label">What do you need?</label>
  //           <select
  //             name="service"
  //             className="homeInput"
  //             value={bannerForm.service}
  //             onChange={handleBannerChange}
  //              autoComplete="email"
  //           >
  //             <option value="">Select service</option>
  //             <option value="website-development">Website development</option>
  //             <option value="web-app-software">Web application / custom software</option>
  //             <option value="chrome-extension">Chrome / browser extension development</option>
  //             <option value="ecommerce-website">E-commerce website</option>
  //             <option value="landing-page-funnel">Landing page / funnel</option>
  //             <option value="mobile-app">Mobile app development</option>
  //             <option value="maintenance-support">Maintenance &amp; support</option>
  //           </select>
  //         </div>

  //         {/* Email */}
  //         <div style={{ marginBottom: "14px" }}>
  //           <label className="home_label">Email</label>
  //           <input
  //             type="email"
  //             name="email"
  //             placeholder="you@example.com"
  //             className="homeInput"
  //             value={bannerForm.email}
  //             onChange={handleBannerChange}
  //           />
  //         </div>

  //         <button type="submit" className="homeSubmitButton" disabled={bannerLoading}>
  //           <span>{bannerLoading ? "Sending..." : "Submit"}</span>
  //         </button>
  //       </form>
  //     </div>
  //   );
  // };

  return (
    <section className="banner-section-three">
      <div
        className={`main-slider-carousel owl-carousel owl-theme ${
          isCarouselReady ? "is-ready" : "is-loading"
        }`}
      >
        {/* SLIDE 1 */}
        <div
          className="slide banner-slide-website"
          style={{
            backgroundImage: `url(${heroMobileAppImage})`,
            position: "relative",
          }}
        >
          <div className="color-layer" />

          <div className="auto-container">
            {/* <div className="content-column clearfix">
              <div className="inner-column-Banner text-white"> */}
              <div className="content-column clearfix centered">
              <div className="inner-column-Banner text-white banner-center">
                <h1>Website Development Company in Modasa</h1>
                <div className="text-base">
                  We build clear and fast websites for growing brands. Our team keeps the work simple
                  and smooth. You get a site that feels clean and helps you reach more people.
                </div>
                <a
                href="https://wa.me/919978623133"
                target="_blank"
                rel="noopener noreferrer"
                className="banner-whatsapp-btn"
              >
                <FaWhatsapp className="whatsapp-icon" />
                <span>Chat on WhatsApp</span>
              </a>


              </div>
              
            </div>
          </div>

          {/* {renderForm()} */}
        </div>

        {/* SLIDE 2 */}
        <div
          className="slide banner-slide-digital"
          style={{
            backgroundImage: deferredSlidesReady ? `url(${heroDigitalMarketingImage})` : "none",
            backgroundColor: "#132144",
            position: "relative",
          }}
        >
          <div className="color-layer" />

          <div className="auto-container">
            {/* <div className="content-column clearfix">
              <div className="inner-column-Banner text-white"> */}
              <div className="content-column clearfix centered">
              <div className="inner-column-Banner text-white banner-center">
                <h2>Digital Marketing Agency in Modasa</h2>
                <div className="text-base">
                  Growing your brand online with our digital marketing agency in Modasa. We manage
                  SEO, ads and social media so your business gets more calls and enquiries.
                </div>
                 <a
                href="https://wa.me/919978623133"
                target="_blank"
                rel="noopener noreferrer"
                className="banner-whatsapp-btn"
              >
                <FaWhatsapp className="whatsapp-icon" />
                <span>Chat on WhatsApp</span>
              </a>

              </div>
            </div>
          </div>

          {/* {renderForm()} */}
        </div>

        {/* SLIDE 3 */}
        <div
          className="slide banner-slide-software"
          style={{
            backgroundImage: deferredSlidesReady ? `url(${softwareSlideImage})` : "none",
            backgroundColor: "#132144",
            position: "relative",
          }}
        >
          <div className="color-layer" />

          <div className="auto-container">
            {/* <div className="content-column clearfix">
              <div className="inner-column-Banner text-white"> */}
              <div className="content-column clearfix centered">
              <div className="inner-column-Banner text-white banner-center">
                <h2>Software Development Company in Modasa</h2>
                <div className="text-base text-bold">
                  We make smooth and easy software for teams in Modasa. Our work fits your daily
                  needs and keeps your process simple. You get tools that feel light and support your
                  business.
                </div>
                            {/* <a
                href="https://wa.me/919978623133"
                target="_blank"
                rel="noopener noreferrer"
                className="banner-whatsapp-btn"
              >
                <span className="whatsapp-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 32 32"
                    fill="currentColor"
                  >
                    <path d="M19.11 17.44c-.29-.15-1.72-.85-1.99-.95-.27-.1-.47-.15-.66.15-.2.29-.76.95-.93 1.15-.17.2-.34.22-.63.07-.29-.15-1.24-.46-2.36-1.46-.87-.78-1.46-1.75-1.63-2.04-.17-.29-.02-.45.13-.6.13-.13.29-.34.44-.51.15-.17.2-.29.29-.49.1-.2.05-.37-.02-.52-.07-.15-.66-1.59-.9-2.18-.24-.57-.49-.49-.66-.5-.17-.01-.37-.01-.56-.01s-.52.07-.79.37c-.27.29-1.04 1.02-1.04 2.49s1.07 2.89 1.22 3.09c.15.2 2.11 3.23 5.12 4.53.72.31 1.28.5 1.72.64.72.23 1.38.2 1.9.12.58-.09 1.72-.7 1.97-1.37.24-.67.24-1.24.17-1.37-.07-.13-.27-.2-.56-.35z"/>
                  </svg>
                </span>
                <span>Chat on WhatsApp</span>
              </a> */}
               <a
                href="https://wa.me/919978623133"
                target="_blank"
                rel="noopener noreferrer"
                className="banner-whatsapp-btn"
              >
                <FaWhatsapp className="whatsapp-icon" />
                <span>Chat on WhatsApp</span>
              </a>
              </div>
            </div>
          </div>

          {/* {renderForm()} */}
        </div>
      </div>
    </section>
  );
};

export default Banner;

